import React from 'react';
import { Outlet } from 'react-router';

import { DashboardLayout } from '@freelancelabs/components';

import Footer from './Footer';
import Sidebar from './Sidebar';

const Layout = () => {
    return (
        <DashboardLayout sidebar={<Sidebar />}>
            <Outlet />
            <Footer />
        </DashboardLayout>
    );
};

export default Layout;
